var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.theme === 'tapcoin' && _vm.web3Config.hasOwnProperty('version') && _vm.web3Config.version > 1 ? _c('n-menu') : _c('u-menu');
};
var staticRenderFns = [];
export { render, staticRenderFns };